$(document).ready(function(){

  $('.submit_validate').submit(function(){
  
    var email = $(this).children('input[type=email]').val();
    var msj = $(this).children('.show-error-validate');
    expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if ( !expr.test(email) ){
        msj.show();
        msj.text('Enter a valid email address');
      return false;       
    }else{
      msj.hide();
    }
    
  });      


  
$('#change-link-to').on('change', function () {
      
      window.location = $(this).val();
});

  $('.button--cart').prepend('<i class="fa fa-shopping-cart"></i> ');
  
  var qty = $('.product__form input[name=quantity]');
  var minus = $('.minus-qty');
  var plus = $('.plus-qty');
  
  plus.click(function(e){
    e.preventDefault();
    var qty_val = parseInt(qty.attr('value'));
    qty_val = qty_val + 1;
    qty.attr('value',qty_val);
  });
  
  minus.click(function(e){
    e.preventDefault();
    var qty_val = parseInt(qty.attr('value'));
    
    if(qty_val > 1){
        qty_val = qty_val - 1;
      qty.attr('value',qty_val);
    }
  });
  
  
  /* Smooth  */
  
    $('a.smooth').on('click', function(e) {
    
    e.preventDefault();
      var $link = $(this);
      var anchor  = $link.attr('href');
      $('html, body').stop().animate({
          scrollTop: $(anchor).offset().top - 50
      }, 0);
  });
  
  /* End  Smooth */
  
  
  
  /* Read More */
  $('.read-more').click(function(e){
    e.preventDefault();
    var item_show = $(this).attr('href');
    $(''+item_show+'').fadeIn(2000);
    $(this).hide();
    
  });
  /* End Read more*/
   

});

KlaviyoSubscribe.attachToForms('#form-footer', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'form | footer']);
        
    $form.find('[name="email"]').attr('value','Perfect! We will be in touch.');
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");
      
       //Call hotjar
        hj('vpv', '/subscribe-footer/'); 
    }
}); 


KlaviyoSubscribe.attachToForms('#form-connect', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'form | about-page-connect']);
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");
    }
});


KlaviyoSubscribe.attachToForms('#form-awesome', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'form | about-page-awesome']);
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");      
    }
});

KlaviyoSubscribe.attachToForms('#form-blog-mindful-matter-sidebar', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'form | mindful-matter-sidebar']);
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");      
      
        //Call hotjar
        hj('vpv', '/subscribe-mindfull-matter-index/');
    }
  
   
});

/* Mobile Version */
KlaviyoSubscribe.attachToForms('#form-blog-mindful-matter-sidebar-xs', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'form | mindful-matter-sidebar']);
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");      
      
      //Call hotjar
        hj('vpv', '/subscribe-mindfull-matter-index/');
    }
});



KlaviyoSubscribe.attachToForms('#form-article', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'form | mindful-matter-article']);
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");      
    }
});


KlaviyoSubscribe.attachToForms('#form-download', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        var title_download = 'manifesto-wallpaper';
      
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'manifesto-wallpaper']);      
        _learnq.push(['track', 'form | downloads', {
              "Title": title_download
         }]);
      
      
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        //$form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");
      
        //Call hotjar
        hj('vpv', '/request-manifesto-download/'); 
      
   /*   
      setTimeout(function(){
        window.location = '/pages/downloads';
      },2000);
   */
      
    }
   
});

KlaviyoSubscribe.attachToForms('#form-download-product', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        var title_download = 'brainpickings-wallpaper';
      
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'brainpickings-wallpaper']);      
        _learnq.push(['track', 'form | downloads', {
              "Title": title_download
         }]);
      
      
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        //$form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");
      
   /*   
      setTimeout(function(){
        window.location = '/pages/downloads';
      },2000);
   */
      
    }
   
});



KlaviyoSubscribe.attachToForms('#form-reflection-download', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        var title_download = 'reflection-worksheet';
      
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]);        
        _learnq.push(['track', 'reflection-worksheet']);      
        _learnq.push(['track', 'form | downloads', {
              "Title": title_download
         }]);
      
      
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        //$form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");
      
   /*   
      setTimeout(function(){
        window.location = '/pages/downloads';
      },2000);
   */
      
    }
   
});

KlaviyoSubscribe.attachToForms('#form-wholesale', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        var name  = $form.find('[name="name"]').val();
        var store = $form.find('[name="store"]').val();        
      
        _learnq.push(['account', 'anGuqF']);
        _learnq.push(['identify',
          function() {
              var names = name.split(" ");
              var identify = {};
              identify["$email"] = email;
              if (names[0]) identify["$first_name"] = names[0];
              if (names[1]) identify["$last_name"] = names[1];
              return identify;
          }()
         ]);
         _learnq.push(['track', 'form | modal-wholesale', {
                "store": store
         }]);
      
        $form.find('[name="name"]').attr("disabled", "disabled");
        $form.find('[name="store"]').attr("disabled", "disabled");
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" Thanks!");      
    }
});


KlaviyoSubscribe.attachToForms('#form-sold-out', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        var product_sku = $form.find('[name="product-sku"]').val();
        var product_title = $form.find('[name="product-title"]').val();
        var product_variant = $form.find('[name="product-variant"]').val();
      
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]); 
         _learnq.push(['track', 'form | modal-sold-out', {
              "product-sku": product_sku,
              "product-title": product_title,
              "product-variant":product_variant
         }]);

    $form.find('[name="email"]').attr('value','Perfect! We will be in touch.');
        $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').addClass("disabled-button");
        $form.find('button').attr("disabled", "disabled");
        $form.find('button').prepend('<i class="fa fa-check-circle"></i> ');
        $form.find(".connected-status").text(" THANKS");      
    }
});


KlaviyoSubscribe.attachToForms('#form-subscription-regular', {
    hide_form_on_success: false,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
        var firstname = $form.find('[name="first_name"]').val();
        var title_download = $form.find('[name="klaviyo-variant-name"]').val();
      
        _learnq.push(['account', 'c2MSrU']);      
        _learnq.push(['identify',
            function() {
              var names = name.split(" ");
              var identify = {};
              identify["$email"] = email;
              identify["$first_name"] = firstname
              return identify;
          }()
         ]);
        _learnq.push(['track', 'sub-checkout-started']);      
        _learnq.push(['track', 'form | sub-checkout-started', {
              "Title": title_download
         }]);
        
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        //$form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");
    }
   
});


KlaviyoSubscribe.attachToForms('#form-subscription-gift-1', {
    hide_form_on_success: false,
    success: function ($form) {  
        var email = $form.find('[name="email"]').val();
        var firstname = $form.find('[name="first_name"]').val();
        var title_download = $form.find('[name="klaviyo-variant-name-gift"]').val();
     
        _learnq.push(['account', 'c2MSrU']);
       _learnq.push(['identify',
            function() {
              var names = name.split(" ");
              var identify = {};
              identify["$email"] = email;
              identify["$first_name"] = firstname
              return identify;
          }()
         ]);
        _learnq.push(['track', 'sub-gift-checkout-started']);      
        _learnq.push(['track', 'form | sub-gift-checkout-started', {
              "Title": title_download
         }]);
          
      
    $form.find('[name="email"]').attr("disabled", "disabled");
        $form.find('button').attr("disabled", "disabled");
        //$form.find('button').prepend('<i class="fa fa-check-square"></i> ');
        $form.find(".connected-status").text(" You're in");
    }
   
});

setTimeout(function(){ 
KlaviyoSubscribe.attachToForms('div.klaviyo_flyout_k3mHQf .klaviyo_subscription_form', {
    hide_form_on_success: true,
  custom_success_message: true,
    success: function ($form) {
        var email = $form.find('[name="email"]').val();
      
        _learnq.push(['account', 'c2MSrU']);
        _learnq.push(['identify', { $email: email }]); 
        _learnq.push(['track', 'form | mm-flyout', {
              "Title": "Article Subscription"
         }]);
     
      
      //Call hotjar
      hj('vpv', '/subscribe-mindfull-matter-article/');
      
      $form.css('display','none');      
    }
   
});
}, 3000);  
  




